import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'

export default {
    computed: {
        ...mapGetters({
            bursaryApplicationReceived: 'bursaryApplications/BursaryApplication',
            emaApplicationReceived: 'emaApplications/EMAApplication',
            childcareApplicationReceived: 'childcareApplications/ChildcareApplication',
            housingApplicationReceived: 'housingApplications/HousingApplication',
            financialAssistanceApplicationReceived: 'financialAssistanceApplications/FinancialAssistanceApplication',
        }),
        IsNewApplication() { return (this.application?.id || 0) == 0; },
    },
    methods: {
        ...mapActions({
            FetchBursaryApplication: 'bursaryApplications/FetchBursaryApplication',
            FetchBursaryApplicationByCourseCode: 'bursaryApplications/FetchBursaryApplicationByCourseCode',
            InsertBursaryApplication: 'bursaryApplications/InsertBursaryApplication',
            UpdateBursaryApplication: 'bursaryApplications/UpdateBursaryApplication',
            UpdateBursaryApplicationBypassEvidenceFields: 'bursaryApplications/UpdateBursaryApplicationBypassEvidenceFields',
            UpdateBursaryApplicationLastPageAccessed: 'bursaryApplications/UpdateBursaryApplicationLastPageAccessed',
            SubmitBursaryApplication: 'bursaryApplications/SubmitBursaryApplication',
            CancelBursaryApplication: 'bursaryApplications/CancelBursaryApplication',
            DeleteBursaryApplication: 'bursaryApplications/DeleteBursaryApplication',

            FetchEMAApplication: 'emaApplications/FetchEMAApplication',
            FetchEMAApplicationByCourseCode: 'emaApplications/FetchEMAApplicationByCourseCode',
            InsertEMAApplication: 'emaApplications/InsertEMAApplication',
            UpdateEMAApplication: 'emaApplications/UpdateEMAApplication',
            UpdateEMAApplicationBypassEvidenceFields: 'emaApplications/UpdateEMAApplicationBypassEvidenceFields',
            UpdateEMAApplicationLastPageAccessed: 'emaApplications/UpdateEMAApplicationLastPageAccessed',
            SubmitEMAApplication: 'emaApplications/SubmitEMAApplication',
            CancelEMAApplication: 'emaApplications/CancelEMAApplication',
            DeleteEMAApplication: 'emaApplications/DeleteEMAApplication',

            FetchChildcareApplication: 'childcareApplications/FetchChildcareApplication',
            InsertChildcareApplication: 'childcareApplications/InsertChildcareApplication',
            UpdateChildcareApplication: 'childcareApplications/UpdateChildcareApplication',
            UpdateChildcareApplicationBypassEvidenceFields: 'childcareApplications/UpdateChildcareApplicationBypassEvidenceFields',
            UpdateChildcareApplicationLastPageAccessed: 'childcareApplications/UpdateChildcareApplicationLastPageAccessed',
            SubmitChildcareApplication: 'childcareApplications/SubmitChildcareApplication',
            CancelChildcareApplication: 'childcareApplications/CancelChildcareApplication',
            DeleteChildcareApplication: 'childcareApplications/DeleteChildcareApplication',

            FetchHousingApplication: 'housingApplications/FetchHousingApplication',
            InsertHousingApplication: 'housingApplications/InsertHousingApplication',
            UpdateHousingApplication: 'housingApplications/UpdateHousingApplication',
            UpdateHousingApplicationBypassEvidenceFields: 'housingApplications/UpdateHousingApplicationBypassEvidenceFields',
            UpdateHousingApplicationLastPageAccessed: 'housingApplications/UpdateHousingApplicationLastPageAccessed',
            SubmitHousingApplication: 'housingApplications/SubmitHousingApplication',
            CancelHousingApplication: 'housingApplications/CancelHousingApplication',
            DeleteHousingApplication: 'housingApplications/DeleteHousingApplication',

            FetchFinancialAssistanceApplication: 'financialAssistanceApplications/FetchFinancialAssistanceApplication',
            InsertFinancialAssistanceApplication: 'financialAssistanceApplications/InsertFinancialAssistanceApplication',
            UpdateFinancialAssistanceApplication: 'financialAssistanceApplications/UpdateFinancialAssistanceApplication',
            UpdateFinancialAssistanceApplicationBypassEvidenceFields: 'financialAssistanceApplications/UpdateFinancialAssistanceApplicationBypassEvidenceFields',
            UpdateFinancialAssistanceApplicationLastPageAccessed: 'financialAssistanceApplications/UpdateFinancialAssistanceApplicationLastPageAccessed',
            SubmitFinancialAssistanceApplication: 'financialAssistanceApplications/SubmitFinancialAssistanceApplication',
            CancelFinancialAssistanceApplication: 'financialAssistanceApplications/CancelFinancialAssistanceApplication',
            DeleteFinancialAssistanceApplication: 'financialAssistanceApplications/DeleteFinancialAssistanceApplication',
        }),
        ResetApplication() {
            switch (this.FormType?.toLowerCase()) {
                case 'bursary':
                    this.application = {
                        id: parseInt(this.$route.params.applicationID) || 0,
                        studentID: this.student.StudentID,
                        studentReference: this.student.StudentReference,
                        academicSession: this.courseApplication?.AcademicSession ?? this.constants.CurrentAcademicYear,
                        formSlug: this.form.slug,
                        courseCode: this.$route.params.courseCode,
                        courseName: this.$route.params.courseName,
                        status: 'Unsubmitted',
                        lastPageAccessed: 'funding-information'
                    };
                    break;
                case 'ema':
                    this.application = {
                        id: parseInt(this.$route.params.applicationID) || 0,
                        studentID: this.student.StudentID,
                        studentReference: this.student.StudentReference,
                        academicSession: this.courseApplication?.AcademicSession ?? this.constants.CurrentAcademicYear,
                        formSlug: this.form.slug,
                        courseCode: this.$route.params.courseCode,
                        courseName: this.$route.params.courseName,
                        status: 'Unsubmitted',
                        lastPageAccessed: 'funding-information'
                    };
                    break;
                case 'fechildcare':
                    this.application = {
                        id: parseInt(this.$route.params.applicationID) || 0,
                        studentID: this.student.StudentID,
                        studentReference: this.student.StudentReference,
                        academicSession: this.courseApplication?.AcademicSession ?? this.constants.CurrentAcademicYear,
                        formSlug: this.form.slug,
                        courseCode: this.$route.params.courseCode,
                        courseName: this.$route.params.courseName,
                        status: 'Unsubmitted',
                        lastPageAccessed: 'eligibility'
                    };

                    // For FE forms, eligibility fields to be populated from submitted main application 
                    this.PopulateEligibilityData();
                    break;
                case 'hechildcare':
                    this.application = {
                        id: parseInt(this.$route.params.applicationID) || 0,
                        studentID: this.student.StudentID,
                        studentReference: this.student.StudentReference,
                        academicSession: this.courseApplication?.AcademicSession ?? this.constants.CurrentAcademicYear,
                        formSlug: this.form.slug,
                        courseCode: this.$route.params.courseCode,
                        courseName: this.$route.params.courseName,
                        status: 'Unsubmitted',
                        lastPageAccessed: 'eligibility'
                    };
                    break;
                case 'hehousing':
                    this.application = {
                        id: parseInt(this.$route.params.applicationID) || 0,
                        studentID: this.student.StudentID,
                        studentReference: this.student.StudentReference,
                        academicSession: this.courseApplication?.AcademicSession ?? this.constants.CurrentAcademicYear,
                        formSlug: this.form.slug,
                        courseCode: this.$route.params.courseCode,
                        courseName: this.$route.params.courseName,
                        status: 'Unsubmitted',
                        lastPageAccessed: 'eligibility'
                    };
                    break;
                case 'financialassistance':
                    this.application = {
                        id: parseInt(this.$route.params.applicationID) || 0,
                        studentID: this.student.StudentID,
                        studentReference: this.student.StudentReference,
                        academicSession: this.courseApplication?.AcademicSession ?? this.constants.CurrentAcademicYear,
                        formSlug: this.form.slug,
                        courseCode: this.$route.params.courseCode,
                        courseName: this.$route.params.courseName,
                        status: 'Unsubmitted',
                        lastPageAccessed: 'eligibility'
                    };

                    // For FE forms, eligibility fields to be populated from submitted main application 
                    this.PopulateEligibilityData();
                    break;
            }

            this.PopulateStudentData();
        },
        PopulateEligibilityData() {
            if (this.application?.courseCode != null) {
                // For FE forms, eligibility fields to be populated from submitted main application 
                this.FetchBursaryApplicationByCourseCode({ CourseCode: this.application.courseCode })
                    .then(bursaryApplication => {
                        if (bursaryApplication != null) {
                            let mainApplication = Object.assign({}, bursaryApplication);

                            if (['Submitted', 'Documents Requested', 'Admin Checked'].includes(mainApplication.status)) {
                                this.application.nationality = mainApplication.nationality;
                                this.application.otherNationality = mainApplication.otherNationality;
                                this.application.hasLeaveToRemain = mainApplication.hasLeaveToRemain;
                                this.application.passportNumber = mainApplication.passportNumber;
                                this.application.countryOfBirth = mainApplication.countryOfBirth;
                                this.application.doesLiveInScotland = mainApplication.doesLiveInScotland;
                                this.application.isUKResident = mainApplication.isUKResident;
                                this.application.isNonUKEUNational = mainApplication.isNonUKEUNational;
                                this.application.isEEAResident = mainApplication.isEEAResident;
                                this.application.countryOfResidence = mainApplication.countryOfResidence;
                                this.application.isMigrantWorker = mainApplication.isMigrantWorker;
                                this.application.isAsylumSeeker = mainApplication.isAsylumSeeker;
                                this.application.isGrantedAsylumUKResident = mainApplication.isGrantedAsylumUKResident;
                                this.application.hasRefugeeStatus = mainApplication.hasRefugeeStatus;
                                this.application.isRefugeeUKResident = mainApplication.isRefugeeUKResident;

                                if (['hehousing', 'financialassistance'].includes(this.FormType?.toLowerCase()) === true) {
                                    this.application.hasBankAccount = mainApplication.hasBankAccount;
                                    this.application.bankAccountName = mainApplication.bankAccountName;
                                    this.application.bankSortCode = mainApplication.bankSortCode;
                                    this.application.bankDetails = mainApplication.bankDetails;
                                    this.application.bankAccountNumber = mainApplication.bankAccountNumber;
                                    this.application.buildingSocietyAccountReference = mainApplication.buildingSocietyAccountReference;
                                }
                            }
                        }
                        else {
                            this.FetchEMAApplicationByCourseCode({ CourseCode: this.application.courseCode })
                                .then(emaApplication => {
                                    if (emaApplication != null) {
                                        let mainApplication = Object.assign({}, emaApplication);

                                        if (['Submitted', 'Documents Requested', 'Admin Checked'].includes(mainApplication.status)) {
                                            this.application.nationality = mainApplication.nationality;
                                            this.application.otherNationality = mainApplication.otherNationality;
                                            this.application.hasLeaveToRemain = mainApplication.hasLeaveToRemain;
                                            this.application.passportNumber = mainApplication.passportNumber;
                                            this.application.countryOfBirth = mainApplication.countryOfBirth;
                                            this.application.doesLiveInScotland = mainApplication.doesLiveInScotland;
                                            this.application.isUKResident = mainApplication.isUKResident;
                                            this.application.isNonUKEUNational = mainApplication.isNonUKEUNational;
                                            this.application.isEEAResident = mainApplication.isEEAResident;
                                            this.application.countryOfResidence = mainApplication.countryOfResidence;
                                            this.application.isMigrantWorker = mainApplication.isMigrantWorker;
                                            this.application.isAsylumSeeker = mainApplication.isAsylumSeeker;
                                            this.application.isGrantedAsylumUKResident = mainApplication.isGrantedAsylumUKResident;
                                            this.application.hasRefugeeStatus = mainApplication.hasRefugeeStatus;
                                            this.application.isRefugeeUKResident = mainApplication.isRefugeeUKResident;

                                            if (['hehousing', 'financialassistance'].includes(this.FormType?.toLowerCase()) === true) {
                                                this.application.hasBankAccount = mainApplication.hasBankAccount;
                                                this.application.bankAccountName = mainApplication.bankAccountName;
                                                this.application.bankSortCode = mainApplication.bankSortCode;
                                                this.application.bankDetails = mainApplication.bankDetails;
                                                this.application.bankAccountNumber = mainApplication.bankAccountNumber;
                                                this.application.buildingSocietyAccountReference = mainApplication.buildingSocietyAccountReference;
                                            }
                                        }
                                    }
                                })
                                .catch(error => eventBus.$emit('alert:error', error));
                        }
                    })
                    .catch(error => eventBus.$emit('alert:error', error));
            }
        },
        PopulateStudentData() {
            if (this.application.status == 'Unsubmitted') {
                if (this.application.title == null && this.student.Title != null) {
                    this.application.title =  this.student.Title;
                }

                this.application.firstName = this.student.EffectiveForenames;
                this.application.surname = this.student.EffectiveSurname;

                if (this.application.previousSurname == null && this.student.PreviousName != null) {
                    this.application.previousSurname = this.student.PreviousName;
                }

                this.application.dateOfBirth = this.student.DateOfBirth;
                this.application.ageAtCourseStart = this.courseApplication?.AgeAtCourseStart;

                if (this.application.gender == null && this.student.GenderCode != null) {
                    this.application.gender = this.student.GenderCode;
                }

                this.application.nationalInsuranceNumber = this.student.NationalInsuranceNumber;

                if (this.application.currentAddress == null && this.studentContactDetails.CurrentAddress != null) {
                    this.application.currentAddress = this.student.CurrentAddress;
                }
                if (this.application.currentPostCode == null && this.studentContactDetails.CurrentPostCode != null) {
                    this.application.currentPostCode = this.student.CurrentPostCode;
                }
                if (this.application.currentPhoneNumber == null && this.studentContactDetails.CurrentPhoneNumber != null) {
                    this.application.currentPhoneNumber = this.student.CurrentPhoneNumber;
                }

                this.application.mobileNumber = this.studentContactDetails.MobileNumber;
                this.application.emailAddress = this.studentContactDetails.EmailAddress;
            }
        },
        LoadApplication() {
            this.ResetApplication();

            if (this.application.id > 0) {
                eventBus.$emit('application-fetch:started');

                switch (this.FormType?.toLowerCase()) {
                    case 'bursary':
                        this.FetchBursaryApplication({ ID: this.application.id })
                            .then(() => {
                                this.application = Object.assign({}, this.bursaryApplicationReceived);
                                eventBus.$emit('application-fetch:success');
                            })
                            .catch(error => eventBus.$emit('alert:error', error))
                            .finally(() => { eventBus.$emit('application-fetch:finished'); });
                        break;
                    case 'ema':
                        this.FetchEMAApplication({ ID: this.application.id })
                            .then(() => {
                                this.application = Object.assign({}, this.emaApplicationReceived);
                                eventBus.$emit('application-fetch:success');
                            })
                            .catch(error => eventBus.$emit('alert:error', error))
                            .finally(() => { eventBus.$emit('application-fetch:finished'); });
                        break;
                    case 'fechildcare':
                    case 'hechildcare':
                        this.FetchChildcareApplication({ ID: this.application.id })
                            .then(() => {
                                this.application = Object.assign({}, this.childcareApplicationReceived);
                                eventBus.$emit('application-fetch:success');
                            })
                            .catch(error => eventBus.$emit('alert:error', error))
                            .finally(() => { eventBus.$emit('application-fetch:finished'); });
                        break;
                    case 'hehousing':
                        this.FetchHousingApplication({ ID: this.application.id })
                            .then(() => {
                                this.application = Object.assign({}, this.housingApplicationReceived);
                                eventBus.$emit('application-fetch:success');
                            })
                            .catch(error => eventBus.$emit('alert:error', error))
                            .finally(() => { eventBus.$emit('application-fetch:finished'); });
                        break;
                    case 'financialassistance':
                        this.FetchFinancialAssistanceApplication({ ID: this.application.id })
                            .then(() => {
                                this.application = Object.assign({}, this.financialAssistanceApplicationReceived);
                                eventBus.$emit('application-fetch:success');
                            })
                            .catch(error => eventBus.$emit('alert:error', error))
                            .finally(() => { eventBus.$emit('application-fetch:finished'); });
                        break;
                }
            } else eventBus.$emit('application-fetch:finished');
        },
        SaveApplication() {
            var message = { Payload: Object.assign({}, this.application) };

            eventBus.$emit('application-save:started');

            if (this.IsNewApplication) {
                switch (this.FormType?.toLowerCase()) {
                    case 'bursary':
                        this.InsertBursaryApplication(message)
                            .then(response => {
                                this.application.id = parseInt(response.id);
                                eventBus.$emit('alert:success', response);
                                eventBus.$emit('application-save:success');
                            })
                            .catch(error => eventBus.$emit('alert:error', error))
                            .finally(() => eventBus.$emit('application-save:finished'));
                        break;
                    case 'ema':
                        this.InsertEMAApplication(message)
                            .then(response => {
                                this.application.id = parseInt(response.id);
                                eventBus.$emit('alert:success', response);
                                eventBus.$emit('application-save:success');
                            })
                            .catch(error => eventBus.$emit('alert:error', error))
                            .finally(() => eventBus.$emit('application-save:finished'));
                        break;
                    case 'fechildcare':
                    case 'hechildcare':
                        this.InsertChildcareApplication(message)
                            .then(response => {
                                this.application.id = parseInt(response.id);
                                eventBus.$emit('alert:success', response);
                                eventBus.$emit('application-save:success');
                            })
                            .catch(error => eventBus.$emit('alert:error', error))
                            .finally(() => eventBus.$emit('application-save:finished'));
                        break;
                    case 'hehousing':
                        this.InsertHousingApplication(message)
                            .then(response => {
                                this.application.id = parseInt(response.id);
                                eventBus.$emit('alert:success', response);
                                eventBus.$emit('application-save:success');
                            })
                            .catch(error => eventBus.$emit('alert:error', error))
                            .finally(() => eventBus.$emit('application-save:finished'));
                        break;
                    case 'financialassistance':
                        this.InsertFinancialAssistanceApplication(message)
                            .then(response => {
                                this.application.id = parseInt(response.id);
                                eventBus.$emit('alert:success', response);
                                eventBus.$emit('application-save:success');
                            })
                            .catch(error => eventBus.$emit('alert:error', error))
                            .finally(() => eventBus.$emit('application-save:finished'));
                        break;
                }
            }
            else {
                switch (this.FormType?.toLowerCase()) {
                    case 'bursary':
                        this.UpdateBursaryApplication(message)
                            .then(response => {
                                eventBus.$emit('alert:success', response);
                                eventBus.$emit('application-save:success');
                            })
                            .catch(error => eventBus.$emit('alert:error', error))
                            .finally(() => eventBus.$emit('application-save:finished'));
                        break;
                    case 'ema':
                        this.UpdateEMAApplication(message)
                            .then(response => {
                                eventBus.$emit('alert:success', response);
                                eventBus.$emit('application-save:success');
                            })
                            .catch(error => eventBus.$emit('alert:error', error))
                            .finally(() => eventBus.$emit('application-save:finished'));
                        break;
                    case 'fechildcare':
                    case 'hechildcare':
                        this.UpdateChildcareApplication(message)
                            .then(response => {
                                eventBus.$emit('alert:success', response);
                                eventBus.$emit('application-save:success');
                            })
                            .catch(error => eventBus.$emit('alert:error', error))
                            .finally(() => eventBus.$emit('application-save:finished'));
                        break;
                    case 'hehousing':
                        this.UpdateHousingApplication(message)
                            .then(response => {
                                eventBus.$emit('alert:success', response);
                                eventBus.$emit('application-save:success');
                            })
                            .catch(error => eventBus.$emit('alert:error', error))
                            .finally(() => eventBus.$emit('application-save:finished'));
                        break;
                    case 'financialassistance':
                        this.UpdateFinancialAssistanceApplication(message)
                            .then(response => {
                                eventBus.$emit('alert:success', response);
                                eventBus.$emit('application-save:success');
                            })
                            .catch(error => eventBus.$emit('alert:error', error))
                            .finally(() => eventBus.$emit('application-save:finished'));
                        break;
                }
            }
        },
        SaveBypassEvidenceFields() {
            eventBus.$emit('application-save-bypass-evidence-fields:started');

            var message = {
                ID: this.application.id,
                BypassEvidenceFields: this.application.bypassEvidenceFields,
            };

            switch (this.FormType?.toLowerCase()) {
                case 'bursary':
                    this.UpdateBursaryApplicationBypassEvidenceFields(message)
                        .then(() => eventBus.$emit('application-save-bypass-evidence-fields:success'))
                        .catch(error => eventBus.$emit('alert:error', error))
                        .finally(() => eventBus.$emit('application-save-bypass-evidence-fields:finished'));
                    break;
                case 'ema':
                    this.UpdateEMAApplicationBypassEvidenceFields(message)
                        .then(() => eventBus.$emit('application-save-bypass-evidence-fields:success'))
                        .catch(error => eventBus.$emit('alert:error', error))
                        .finally(() => eventBus.$emit('application-save-bypass-evidence-fields:finished'));
                    break;
                case 'fechildcare':
                case 'hechildcare':
                    this.UpdateChildcareApplicationBypassEvidenceFields(message)
                        .then(() => eventBus.$emit('application-save-bypass-evidence-fields:success'))
                        .catch(error => eventBus.$emit('alert:error', error))
                        .finally(() => eventBus.$emit('application-save-bypass-evidence-fields:finished'));
                    break;
                case 'hehousing':
                    this.UpdateHousingApplicationBypassEvidenceFields(message)
                        .then(() => eventBus.$emit('application-save-bypass-evidence-fields:success'))
                        .catch(error => eventBus.$emit('alert:error', error))
                        .finally(() => eventBus.$emit('application-save-bypass-evidence-fields:finished'));
                    break;
                case 'financialassistance':
                    this.UpdateFinancialAssistanceApplicationBypassEvidenceFields(message)
                        .then(() => eventBus.$emit('application-save-bypass-evidence-fields:success'))
                        .catch(error => eventBus.$emit('alert:error', error))
                        .finally(() => eventBus.$emit('application-save-bypass-evidence-fields:finished'));
                    break;
            }
        },
        UpdateLastPageAccessed(page) {
            switch (this.FormType?.toLowerCase()) {
                case 'bursary':
                    this.UpdateBursaryApplicationLastPageAccessed({ ID: this.application.id, Page: page })
                        .catch(error => eventBus.$emit('alert:error', error));
                    break;
                case 'ema':
                    this.UpdateEMAApplicationLastPageAccessed({ ID: this.application.id, Page: page })
                        .catch(error => eventBus.$emit('alert:error', error));
                    break;
                case 'fechildcare':
                case 'hechildcare':
                    this.UpdateChildcareApplicationLastPageAccessed({ ID: this.application.id, Page: page })
                        .catch(error => eventBus.$emit('alert:error', error));
                    break;
                case 'hehousing':
                    this.UpdateHousingApplicationLastPageAccessed({ ID: this.application.id, Page: page })
                        .catch(error => eventBus.$emit('alert:error', error));
                    break;
                case 'financialassistance':
                    this.UpdateFinancialAssistanceApplicationLastPageAccessed({ ID: this.application.id, Page: page })
                        .catch(error => eventBus.$emit('alert:error', error));
                    break;
            }
        },
        SubmitApplication() {
            switch (this.FormType?.toLowerCase()) {
                case 'bursary':
                    eventBus.$emit('application-submit:started');
                    this.SubmitBursaryApplication({ Payload: Object.assign({}, this.application) })
                        .then(response => {
                            eventBus.$emit('alert:success', response);
                            eventBus.$emit('application-submit:success');
                        })
                        .catch(error => eventBus.$emit('alert:error', error))
                        .finally(() => eventBus.$emit('application-submit:finished'));
                    break;
                case 'ema':
                    eventBus.$emit('application-submit:started');
                    this.SubmitEMAApplication({ Payload: Object.assign({}, this.application) })
                        .then(response => {
                            eventBus.$emit('alert:success', response);
                            eventBus.$emit('application-submit:success');
                        })
                        .catch(error => eventBus.$emit('alert:error', error))
                        .finally(() => eventBus.$emit('application-submit:finished'));
                    break;
                case 'fechildcare':
                case 'hechildcare':
                    eventBus.$emit('application-submit:started');
                    this.SubmitChildcareApplication({ Payload: Object.assign({}, this.application) })
                        .then(response => {
                            eventBus.$emit('alert:success', response);
                            eventBus.$emit('application-submit:success');
                        })
                        .catch(error => eventBus.$emit('alert:error', error))
                        .finally(() => eventBus.$emit('application-submit:finished'));
                    break;
                case 'hehousing':
                    eventBus.$emit('application-submit:started');
                    this.SubmitHousingApplication({ Payload: Object.assign({}, this.application) })
                        .then(response => {
                            eventBus.$emit('alert:success', response);
                            eventBus.$emit('application-submit:success');
                        })
                        .catch(error => eventBus.$emit('alert:error', error))
                        .finally(() => eventBus.$emit('application-submit:finished'));
                    break;
                case 'financialassistance':
                    eventBus.$emit('application-submit:started');
                    this.SubmitFinancialAssistanceApplication({ Payload: Object.assign({}, this.application) })
                        .then(response => {
                            eventBus.$emit('alert:success', response);
                            eventBus.$emit('application-submit:success');
                        })
                        .catch(error => eventBus.$emit('alert:error', error))
                        .finally(() => eventBus.$emit('application-submit:finished'));
                    break;
            }
        },
        CancelApplication(reason) {
            let message = {
                Payload: Object.assign({}, this.application),
                Reason: reason
            };
            switch (this.FormType?.toLowerCase()) {
                case 'bursary':
                    eventBus.$emit('application-cancel:started');
                    this.CancelBursaryApplication(message)
                        .then(response => {
                            eventBus.$emit('alert:success', response);
                            eventBus.$emit('application-cancel:success');
                        })
                        .catch(error => eventBus.$emit('alert:error', error))
                        .finally(() => eventBus.$emit('application-cancel:finished'));
                    break;
                case 'ema':
                    eventBus.$emit('application-cancel:started');
                    this.CancelEMAApplication(message)
                        .then(response => {
                            eventBus.$emit('alert:success', response);
                            eventBus.$emit('application-cancel:success');
                        })
                        .catch(error => eventBus.$emit('alert:error', error))
                        .finally(() => eventBus.$emit('application-cancel:finished'));
                    break;
                case 'fechildcare':
                case 'hechildcare':
                    eventBus.$emit('application-cancel:started');
                    this.CancelChildcareApplication(message)
                        .then(response => {
                            eventBus.$emit('alert:success', response);
                            eventBus.$emit('application-cancel:success');
                        })
                        .catch(error => eventBus.$emit('alert:error', error))
                        .finally(() => eventBus.$emit('application-cancel:finished'));
                    break;
                case 'hehousing':
                    eventBus.$emit('application-cancel:started');
                    this.CancelHousingApplication(message)
                        .then(response => {
                            eventBus.$emit('alert:success', response);
                            eventBus.$emit('application-cancel:success');
                        })
                        .catch(error => eventBus.$emit('alert:error', error))
                        .finally(() => eventBus.$emit('application-cancel:finished'));
                    break;
                case 'financialassistance':
                    eventBus.$emit('application-cancel:started');
                    this.CancelFinancialAssistanceApplication(message)
                        .then(response => {
                            eventBus.$emit('alert:success', response);
                            eventBus.$emit('application-cancel:success');
                        })
                        .catch(error => eventBus.$emit('alert:error', error))
                        .finally(() => eventBus.$emit('application-cancel:finished'));
                    break;
            }
        },
        DeleteApplication(application) {
            let message = { ID: application.id };

            switch (application.formType?.toLowerCase()) {
                case 'bursary':
                    eventBus.$emit('application-delete:started');
                    this.DeleteBursaryApplication(message)
                        .then(response => {
                            eventBus.$emit('alert:success', response);
                            eventBus.$emit('application-delete:success');
                        })
                        .catch(error => eventBus.$emit('alert:error', error))
                        .finally(() => eventBus.$emit('application-delete:finished'));
                    break;
                case 'ema':
                    eventBus.$emit('application-delete:started');
                    this.DeleteEMAApplication(message)
                        .then(response => {
                            eventBus.$emit('alert:success', response);
                            eventBus.$emit('application-delete:success');
                        })
                        .catch(error => eventBus.$emit('alert:error', error))
                        .finally(() => eventBus.$emit('application-delete:finished'));
                    break;
                case 'fechildcare':
                case 'hechildcare':
                    eventBus.$emit('application-delete:started');
                    this.DeleteChildcareApplication(message)
                        .then(response => {
                            eventBus.$emit('alert:success', response);
                            eventBus.$emit('application-delete:success');
                        })
                        .catch(error => eventBus.$emit('alert:error', error))
                        .finally(() => eventBus.$emit('application-delete:finished'));
                    break;
                case 'hehousing':
                    eventBus.$emit('application-delete:started');
                    this.DeleteHousingApplication(message)
                        .then(response => {
                            eventBus.$emit('alert:success', response);
                            eventBus.$emit('application-delete:success');
                        })
                        .catch(error => eventBus.$emit('alert:error', error))
                        .finally(() => eventBus.$emit('application-delete:finished'));
                    break;
                case 'financialassistance':
                    eventBus.$emit('application-delete:started');
                    this.DeleteFinancialAssistanceApplication(message)
                        .then(response => {
                            eventBus.$emit('alert:success', response);
                            eventBus.$emit('application-delete:success');
                        })
                        .catch(error => eventBus.$emit('alert:error', error))
                        .finally(() => eventBus.$emit('application-delete:finished'));
                    break;
            }
        },
    },
};